import React, { Component } from 'react'
import { REACTIONS } from '../../../src/global/obj/global'

global.isclient && require('./rxReactionSelector.css')
const { subString } = global.rootRequire('classes/ulti')
const { checkNameUser } = global.rootRequire('classes/chat')

class RxSelectIcons extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {    
    }
  }

  tagName_SelectUser(ele) {  
    ele.name_contact = subString(checkNameUser(ele), 20)
    this.props.onClick(ele)              
  }

  addEmoji = (e, index) => {
    e.stopPropagation()
    this.props.onClick(e.target)
  }

  render() {
    let arrTabs = REACTIONS
    return (
      <div className='emoji_message_wrap'>
        <div className='emoji_message_body'>
          {arrTabs.map((vEmoji, index) => (
            <div key={'emoji-' + index} className='emoji_message_icon' onClick={this.addEmoji}>{vEmoji}</div> 
          ))}
        </div>
      </div> 
    )
  }
}

RxSelectIcons.defaultProps = {onChange: () => { }, onClick: () => { } 
}

export default RxSelectIcons